import ajaxService from "../utils/ajaxServices";
import { ProductCarouselData } from "../config/queries";

export const postPageComponents = async (data) => {
  // API call
  try {
    const result = await ajaxService.httpPost(
      "drupalBaseUrl",
      JSON.stringify(data),
      "api",
      "getPage"
    );
    return result;
  } catch (error) {
    console.log("page service failure", error);
  }
};

export const getPageComponents = async (url) => {
  // API call
  try {
    const result = await ajaxService.httpGet(
      "drupalBaseUrl",
      "",
      "api",
      "getPage",
      url
    );
    return result;
  } catch (error) {
    console.log("page service failure", error);
  }
}

export const productCarouselService = async (sku) => {
  const result = await ajaxService.fetchGraphQLPOSTRequest(ProductCarouselData, {
    id: sku,
  });
  return result;
};
